export default __webpack_public_path__ + "static/media/q2_2_step3.50df6fe2.png";